<template>
  <Modal :value="value" @input="closeModal" width="lg">
    <div slot="header">
      {{ header }}
    </div>

    <Panel :data="data" :deep="deep" />
    <div slot="footer">
      <button class="btn btn-outline" @click="download">Download</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/shares/specialTag/Modal'
import Panel from '@/components/admin/maestro/Panel'
import DownloadCreator from '@/models/DownloadCreator'

export default {
  components: {
    Modal,
    Panel
  },
  methods: {
    closeModal() {
      this.$emit('input', false)
    },
    download() {
      const string = JSON.stringify(this.data, null, 2)
      const id = this.data.id ? this.data.id : 'data'
      DownloadCreator.download(`${id}.json`, string)
    },
  },
  name: 'ShowDataModal',
  props: {
    value: { default: false, type: Boolean },
    header: { default: 'Data', type: String },
    data: { required: true, type: Object },
    deep: { type: Number, default: 2 }
  },
}
</script>

<style scoped></style>
